import request from "@/utils/request";

//获取数据列表
export function getList(params) {
  return request({
    url: "/scl90/patient/",
    method: "get",
    params,
  });
}
